import { render } from "./OtiForOp.vue?vue&type=template&id=d5bdee78&scoped=true"
import script from "./OtiForOp.vue?vue&type=script&lang=js"
export * from "./OtiForOp.vue?vue&type=script&lang=js"

import "./OtiForOp.vue?vue&type=style&index=0&id=d5bdee78&scoped=true&lang=css"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5bdee78"]])

export default __exports__